import { Formik, FormikHelpers } from "formik";
import { WisaTabletFormInitValues } from "../../interfaces/fe.interfaces";
import styles from "./styles.module.scss";
import { validateWiSATablets } from "../../utils/validationSchemas";
import Form from "./Form";
import { http } from "../../api/utils/http";
import { addWiSATablets } from "../../api/config";
import moment from "moment";
import { toast } from "react-toastify";

// Initial values for adding new tablet
const initialValues: WisaTabletFormInitValues = {
  it_tag: "",
  tablet_device_id: "",
  tablet_name: "",
  tablet_mfg: "",
  rssi: null,
  customer_checked_out_to: null,
  date_shipped: null,
  ship_to_tracking_id: null,
  ship_from_tracking_id: null,
  return_date: moment().add(180, "days").format("YYYY-MM-DD"),
  calibration_date: moment().format("YYYY-MM-DD"),
};

interface AddCertTabletProps {
  onCancelClick: () => void;
  onSuccess: () => void;
}

const AddCertTablet = ({ onCancelClick, onSuccess }: AddCertTabletProps) => {
  // Submit handler for add cert tablet
  const handleSubmit = (data: WisaTabletFormInitValues, { setSubmitting }: FormikHelpers<WisaTabletFormInitValues>) => {
    http.makePostRequest<WisaTabletFormInitValues, { message: string }>(
      addWiSATablets,
      () => {
        onSuccess();
      },
      (error) => {
        setSubmitting(false);
        toast.error(error?.response?.data?.message);
      },
      data
    );
  };

  return (
    <div className={styles.dialogContainer}>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validateWiSATablets}>
        {(props) => <Form {...props} onCancelClick={onCancelClick} />}
      </Formik>
    </div>
  );
};

export default AddCertTablet;
